// © Microsoft Corporation. All rights reserved.
/**
 * Defines valid loading states for an experience
 * The state has been defined as it happens. Please do not update the ordering or the numeric value of states.
 * If the numeric value of the state is updated this will break internal logic.
 */
export enum ExperienceLoadingState {

    /**
   * The experience has not been started yet
   */
    notStarted = 1,

    /**
   * The experience loading has been deferred
   */
    loadDeferred = 2,

    /**
   * The experience is coming out of loadDeferred state and is now resolved to be loaded.
   */
    resolvedForLoad = 3,

    /**
   * The experience has been loaded (i.e. the bundle has been downloaded and parsed, and the connector created)
   */
    loaded = 4,

    /**
   * The experience initialized milestone has been reached
   */
    initialized = 5,

    /**
   * The experience render has been deferred
   */
    renderDeferred = 6,

    /**
   * The experience is coming out of renderDeferred state and is now resolved to be rendered.
   */
    resolvedForRender = 7,

    /**
   * The experience rendered milestone has been reached (render function has been completed)
   */
    rendered = 8,

    /**
   * The experience DOM complete milestone has been reached
   */
    domComplete = 10,

    /**
   * The initial render of the experience has completed. All initial DOM elements have been created, and the browser has completed all render
   * task (applying styles, animations, etc)
   */
    visuallyReady = 11,

    /**
   * The experience encountered an error during loading
   */
    error = 12,

    /**
   * The experience has completed the revalidation of stale state.
   */
    staleRevalidationComplete = 13,

    /**
   * The experience starts loading
   */
    startLoading = 14,
}
